import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/** שעות ומשמרות של עובד בטווח תאריכים (מיגרציה 050). */
export type HoursRow = {
  employee_id: string;
  minutes: number;
  shifts: number;
  /** מכסת שעות. null = בלי מכסה, ולא אפס. */
  weekly_target: number | null;
  monthly_target: number | null;
  /** המכסה החודשית נקבעה לחודש הזה ואינה הקבועה של העובד. */
  month_override: boolean;
  month_override_note: string | null;
};

/**
 * סיכום השעות של החודש.
 *
 * שאילתה נפרדת מהלוח, כי החודש חורג מהשבוע המוצג. היא אינה
 * מקבלת את הסניפים שנבחרו: "כמה שעות יש לאדם הזה החודש" היא
 * שאלה על האדם, ומי שמסתובב בין סניפים צריך את הסכום האמיתי.
 */
export function useScheduleHours(from: string, to: string, enabled = true) {
  return useQuery({
    queryKey: ['schedule-hours', from, to] as const,
    enabled,
    queryFn: async (): Promise<Map<string, HoursRow>> => {
      const { data, error } = await supabase.rpc('schedule_hours', {
        p_from: from,
        p_to: to,
      });
      if (error) throw error;
      const rows = (data ?? []) as unknown as HoursRow[];
      return new Map(rows.map((row) => [row.employee_id, row]));
    },
  });
}
